import Accordion from "../components/patterns/accordion/accordion";
import Body from "./utils/body/body";
import ChatbotTeaser from "../components/patterns/chatbot-teaser/chatbot-teaser";
import ContrastSwitcher from "../components/elements/contrast-switcher/contrast-switcher";
import Countdown from "../components/elements/countdown/countdown";
import DoubleOptInLightbox from "../components/template-components/double-opt-in-lightbox/double-opt-in-lightbox";
import DropdownList from "../components/template-components/header/main-navigation/dropdown-list/dropdown-list";
import ExpendableBlock from "../components/patterns/expendable-block/expendable-block";
import Filters from "../components/patterns/search/filters/filters";
import Flyout from "../components/elements/flyout/flyout";
import Form from "../components/patterns/form/form";
import GiftPrompt from "../components/elements/gift-prompt/gift-prompt";
import Header from "../components/template-components/header/header";
import ImageGallery from "../components/patterns/image-gallery/image-gallery";
import Lightbox from "../components/elements/lightbox/lightbox";
import MainNavigation from "../components/template-components/header/main-navigation/main-navigation";
import Motive from "../components/patterns/motive/motive";
import MultiSelect from "../components/elements/multiselect/multiselect";
import OverlayTeaser from "../components/template-components/overlay-teaser/overlay-teaser";
import OverlayTeaserContent from "../components/template-components/overlay-teaser/overlay-teaser-content/overlay-teaser-content";
import PaypalErrorLightbox from "../components/template-components/paypal-error-lightbox/paypal-error-lightbox";
import PetitionTeaser from "../components/patterns/petition-teaser/petition-teaser";
import Progress from "../components/elements/progress/progress";
import ResizeObserver from "./utils/resize-observer/resize-observer";
import ScrollObserver from "./utils/scroll-observer/scroll-observer";
import Search from "../components/patterns/search/search";
import SearchBar from "../components/template-components/header/search-bar/search-bar";
import SearchResults from "../components/patterns/search-results/search-results";
import Share from "../components/elements/share/share";
import Stage from "../components/patterns/stage/stage";
import SubNavigation from "../components/patterns/sub-navigation/sub-navigation";
import Tabs from "../components/patterns/tabs/tabs";
import Teaser from "../components/elements/teaser/teaser";
import TeaserBody from "../components/patterns/donation-teaser/teaser-body/teaser-body";
import Tracking from "../tracking";
import VisibilityObserver from "./utils/visibilty-observer/visibilty-observer";

import { EVENTS } from "./constants";

import "../components/elements/image/image";

const Factory = {
  ".FskForm": Form,
  ".js-Accordion": Accordion,
  ".js-ChatbotTeaser": ChatbotTeaser,
  ".js-ContrastSwitcher": ContrastSwitcher,
  ".js-Countdown": Countdown,
  ".js-DonationTeaser-form": Form,
  ".js-DoubleOptInLightbox": DoubleOptInLightbox,
  ".js-DropdownList": DropdownList,
  ".js-ExpendableBlock": ExpendableBlock,
  ".js-Filters": Filters,
  ".js-Flyout": Flyout,
  ".js-GiftPrompt": GiftPrompt,
  ".js-Header": Header,
  ".js-ImageGallery": ImageGallery,
  ".js-Lightbox": Lightbox,
  ".js-MainNavigation": MainNavigation,
  ".js-Motive": Motive,
  ".js-MultiSelect": MultiSelect,
  ".js-OverlayTeaser": OverlayTeaser,
  ".js-OverlayTeaser-content": OverlayTeaserContent,
  ".js-PaymentForm": Form,
  ".js-PaypalErrorLightbox": PaypalErrorLightbox,
  ".js-PetitionTeaser": PetitionTeaser,
  ".js-Progress": Progress,
  ".js-Search": Search,
  ".js-SearchBar": SearchBar,
  ".js-SearchResults": SearchResults,
  ".js-Share": Share,
  ".js-Stage": Stage,
  ".js-Stage-form": Form,
  ".js-SubNavigation": SubNavigation,
  ".js-Tabs": Tabs,
  ".js-TeaserBody": TeaserBody,
  ".js-Teaser--petition": Teaser,
};

class App {
  /**
   * Initializes the global App class,
   * used for creating instances of all component classes.
   */
  constructor() {
    /* eslint-disable */
    console.log("DOMContentLoaded");
    /* eslint-enable */
    this.body = new Body(document.body);
    this.bind(document);
    this.scrollObserver = new ScrollObserver(window);
    this.resizeObserver = new ResizeObserver(window);
    this.visibilityObserver = new VisibilityObserver(document, [
      ".js-PetitionTeaser",
      ".js-Progress",
      ".js-Teaser--petition",
    ]);
    this.tracking = new Tracking();

    /**
     * This should be moved somewhere else, but currently the body.js
     * implementation is a bit screwed up as it adds a lot of event listeners
     * to multiple elements. When this is fixed, we could move this as well.
     */
    document.documentElement.addEventListener(EVENTS.CONTRAST, (event) => {
      const contrast = event.detail.contrast === "high";
      document.documentElement.classList.toggle("contrast-high", contrast);
      document.documentElement.classList.toggle("contrast-low", !contrast);
    });
  }

  /**
   * Looks in the given context for elements
   * which are used to create instances of component classes.
   *
   * @param {Document|HTMLElement} context - the context in which the method should look for elements
   */
  bind(context) {
    Object.keys(Factory).forEach((key) => {
      const mangledKey = key.toLowerCase().replace(".js-", "");

      if (!this[mangledKey]) {
        this[mangledKey] = [];
      }

      Array.prototype.push.apply(
        this[mangledKey],
        [].slice.call(context.querySelectorAll(key)).map((element) => {
          const el = new Factory[key](element);
          return el;
        })
      );
    });
  }
}

document.addEventListener("DOMContentLoaded", () => new App(), { once: true });
